exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1C7CkonToSP5cnW4XJJulC{color:var(--neutralSecondary);font-size:16px}", ""]);
// Exports
exports.locals = {
	"icon": "_1C7CkonToSP5cnW4XJJulC"
};